<template>
  <div class="main">
    <Result
      :icon="getIcon('img/credit-line/success_view_icon.png')"
      :title="t('CL_WITHDRAWAL.ACCOUNT_VERIFICATION_MSG')"
      :description="t('CL_WITHDRAWAL.ACCOUNT_VERIFICATION_DESCRIPTION')"
      :btn-text="t('CL_WITHDRAWAL.GO_TO_HOME_BTN')"
      @dismissFunc="dismiss()"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Result from "@/apps/credit-line/components/Result.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { safeAndroidCall } from "@/apps/credit-line/helpers/safe-android-call.helper";
export default defineComponent({
  name: "AccountVerificationRequestView",
  components: { Result },
  methods: {
    getIcon(path: string): string {
      return useAsset(path);
    },
    dismiss() {
      safeAndroidCall("confirmWithdrawal");
      safeAndroidCall("creditOfferAccepted");
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
</style>
